class SizeGuideModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this;
    this.contentElement = this.querySelector('.size-guide__content');
    this.closeTransitionFallback = null;
    this.sizeGuideToggleWrapper = document.querySelector('.product-form__fieldset--size');
    if (this.sizeGuideToggleWrapper) {
      this.sizeGuideToggleWrapper.classList.add('is-active');
    }
    this.sizeguideToggles = document.querySelectorAll('.size-guide-trigger');
    if (this.sizeguideToggles) {
      this.sizeguideToggles.forEach(toggle => {
        toggle.addEventListener('click', this.onToggleClick.bind(this));
      })
    }
    this.closeButton = document.querySelector('.size-guide__close');
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
    this.contentBlock = this.querySelectorAll('.size-guide__accordion-item-trigger')

    this.sizeGuideToggleWrapper.classList.add('is-active')
    this.closeButton.addEventListener('click', this.close.bind(this));

    this.contentBlock.forEach((button) => {
      button.addEventListener('click', this.openAccordion.bind(this))
    })

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close()
      }
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onToggleClick(event) {
    event.preventDefault();
    this.sizeguideToggle = event.currentTarget;
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (event.target.classList.contains('size-guide__overlay')) {
      this.close(false)
    }
  }

  open() {
    window.clearTimeout(this.closeTransitionFallback);
    this.detailsContainer.removeAttribute('closing');
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('[tabindex="-1"]');
        const focusElement = this.querySelector('.size-guide__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.sizeguideToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    if (!this.detailsContainer.hasAttribute('open')) return;

    this.detailsContainer.setAttribute('closing', '');
    this.detailsContainer.removeAttribute('open');

    const finishClose = (event) => {
      if (event && event.target !== this.contentElement) return;
      window.clearTimeout(this.closeTransitionFallback);
      this.detailsContainer.removeAttribute('closing');
    };

    this.contentElement?.addEventListener('transitionend', finishClose, { once: true });
    this.closeTransitionFallback = window.setTimeout(finishClose, 500);
  }

  openAccordion(event) {
    if (event.target.classList.contains('is-active')) {
      event.target.classList.remove('is-active')

    } else {
      this.disableContentBlocks()
      event.target.classList.toggle('is-active')
    }
  }

  disableContentBlocks() {
    this.contentBlock.forEach((button) => {
      button.classList.remove('is-active')
    })
  }
}

customElements.define('size-guide-modal', SizeGuideModal);

/* ------------------------------------------------------------------
   Fallback for dynamic templates (Family-Set etc.)
   If the first query in the constructor found nothing, we delegate.
------------------------------------------------------------------ */
if (!document.querySelector('.size-guide-trigger')) {
  document.addEventListener('click', (e) => {
    if (e.target.closest('.size-guide-trigger')) {
      document.querySelector('size-guide-modal')?.open();
    }
  });
}